import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import OnboardingLandingPage from './pages/OnboardingLandingPage';
import OnboardingEmployerPage from './pages/OnboardingEmployerPage';
import OnboardingCandidatePage from './pages/OnboardingCandidatePage';
import OnboardingChoosePage from './pages/OnboardingChoosePage';
import InviteJoinPage from './pages/InviteJoinPage';
import MatchClaimPage from './pages/MatchClaimPage';
import RequestAccessConfirmPage from './pages/RequestAccessConfirmPage';
import AuthRecoverPage from './pages/AuthRecoverPage';
import NotFoundPage from './pages/NotFoundPage';
import BrandedOnboardingLayout from './layouts/BrandedOnboardingLayout';
import { AnalyticsRouteListener } from './components/AnalyticsRouteListener';
import { signupAuthorizeURL } from './lib/auth-onboarding';

// Preserve query on legacy /login and /signup bounce-backs.
function RedirectToRoot() {
  const { search } = useLocation();
  return <Navigate to={`/${search}`} replace />;
}

// Legacy /signup/candidate deep-link → WorkOS authorize.
function CandidateAuthorizeRedirect() {
  window.location.assign(signupAuthorizeURL('candidate'));
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AnalyticsRouteListener />
      <Routes>
        {/* Full-bleed landing, no shared chrome */}
        <Route index element={<OnboardingLandingPage />} />

        {/* All onboarding and public utility routes share the branded Reed layout. */}
        <Route element={<BrandedOnboardingLayout />}>
          <Route path="onboarding/employer" element={<OnboardingEmployerPage />} />
          <Route path="onboarding/candidate" element={<OnboardingCandidatePage />} />
          <Route path="onboarding/choose" element={<OnboardingChoosePage />} />
          <Route path="join" element={<InviteJoinPage />} />
          <Route path="match/:token" element={<MatchClaimPage />} />
          <Route path="request-access/confirm" element={<RequestAccessConfirmPage />} />
          <Route path="auth/recover" element={<AuthRecoverPage />} />
          <Route path="404" element={<NotFoundPage />} />
        </Route>

        {/* Back-compat redirects */}
        <Route path="signup" element={<RedirectToRoot />} />
        <Route path="login" element={<RedirectToRoot />} />
        <Route path="signup/employer" element={<Navigate to="/onboarding/employer" replace />} />
        <Route path="signup/candidate" element={<CandidateAuthorizeRedirect />} />

        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
